import { NumericFormat } from "react-number-format";
import { FallBackImage } from "../default/fallback-image";
import { format } from 'date-fns';
import { useForm } from "react-hook-form";
import InputMask from 'react-input-mask';
import { useState } from "react";
import { fetchPostEmailSendPurpose } from "../../../services/api";
import { useReCaptcha } from "next-recaptcha-v3";
import StickyBox from "react-sticky-box";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, FreeMode, Navigation } from "swiper";
import Image from "next/image";
import { Button, Modal } from "react-bootstrap";

export default function CarDetails({ ad, company }) {
    const [formPost, setFormPost] = useState({ isLoading: false, isError: false, errorText: '', isSuccess: false });
    const [index, setIndex] = useState(-1);
    const [openYoutubeVideo, setOpenYoutubeVideo] = useState(false);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    // const [showFinancingModal, setShowFinancingModal] = useState({ isOpen: false });
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const { executeRecaptcha } = useReCaptcha();

    const onSubmit = async data => {
        const token = await executeRecaptcha("proposalSubmit");
        setFormPost({ ...formPost, isLoading: true, isError: false, errorText: '', isSuccess: false });
        fetchPostEmailSendPurpose({
            cellPhone: data.txtCellPhone,
            email: data.txtEmail,
            message: data.txtMessage,
            name: data.txtName,
            idAd: ad.id,
            token
        })
            .then(res => {
                if (res) {
                    setValue('txtName', '');
                    setValue('txtEmail', '');
                    setValue('txtCellPhone', '');
                    setValue('txtMessage', '');
                    setFormPost({ ...formPost, isLoading: false, isSuccess: true });
                }
            })
            .catch(err => { setFormPost({ ...formPost, isLoading: false, isError: true, errorText: err.toString() }); });
    }

    return (
        <>
            <section className="inventory-details-area ptb-40">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8">
                            <div className="inventory-details">
                                <div className="product_details widget-padding bg-white rounded">
                                    <span className="btn-meta bg-primary text-white">{`${ad.category} - ${ad.condition.replace('-', '')}`}</span>
                                    <h3 className="mt-2">{`${ad.brand} ${ad.model} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''}`}</h3>
                                    <div className="iv-meta">
                                        <span><i className="fa-solid fa-clock"></i>anunciado em: {format(new Date(ad.datetime), 'dd/MM/yyyy')}</span>
                                    </div>
                                    <div className="iv_double_slider mt-30">
                                        <div className="iv_thumb_slider swiper">
                                            {
                                                ad.videos.length > 0
                                                    ? <div className="watch-video-button">
                                                        <a id="video-popup-btn" onClick={() => setOpenYoutubeVideo(true)} href='#' title={`${ad.brand} ${ad.model} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''}`}><i className="fas fa-play watch-video-button-i"></i>Video do Veículo</a>
                                                    </div>
                                                    : null
                                            }
                                            <Swiper
                                                slidesPerView={1}
                                                navigation={true}
                                                thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                                                modules={[Thumbs, Navigation, FreeMode]}
                                            >
                                                {
                                                    ad.photos.length > 0
                                                        ? ad.photos.map((photo, index) => (
                                                            <SwiperSlide key={index} className="swiper-slide thumb-wrapper rounded overflow-hidden">
                                                                <a onClick={() => setIndex(index)}>
                                                                    <Image
                                                                        src={photo}
                                                                        alt="carro"
                                                                        width={808}
                                                                        height={490}
                                                                        sizes="100vw"
                                                                        style={{ width: "100%", height: "auto", objectFit: "cover" }} />
                                                                </a>
                                                            </SwiperSlide>
                                                        ))
                                                        : (
                                                            <SwiperSlide className="swiper-slide thumb-wrapper rounded overflow-hidden">
                                                                <Image
                                                                    src="/img/no-image.jpeg"
                                                                    alt="Sem imagem disponível"
                                                                    width={808}
                                                                    height={490}
                                                                    sizes="100vw"
                                                                    style={{ width: "100%", height: "auto" }}
                                                                />
                                                            </SwiperSlide>
                                                        )
                                                }
                                            </Swiper>
                                        </div>
                                        {
                                            ad.photos.length > 0 && (
                                                <div className="iv_thumb_control_slider swiper mt-3 mt-lg-4">
                                                    <Swiper
                                                        onSwiper={setThumbsSwiper}
                                                        spaceBetween={24}
                                                        slidesPerView={4}
                                                        freeMode={true}
                                                        watchSlidesProgress={true}
                                                        breakpoints={{
                                                            [0]: {
                                                                slidesPerView: 3,
                                                                spaceBetween: 16
                                                            },
                                                            [992]: {
                                                                slidesPerView: 4,
                                                                spaceBetween: 24
                                                            }
                                                        }}
                                                        modules={[Thumbs, Navigation, FreeMode]}
                                                    >
                                                        {
                                                            ad.photos.length > 0
                                                                ? ad.photos.map((photo, index) =>
                                                                    <SwiperSlide key={index} className="swiper-slide rounded overflow-hidden">
                                                                        <Image
                                                                            src={photo}
                                                                            alt="carro"
                                                                            className="img-slide-thumb-fluid"
                                                                            width={283}
                                                                            height={187} />
                                                                    </SwiperSlide>
                                                                )
                                                                : <div className="swiper-slide rounded overflow-hidden">
                                                                    <Image
                                                                        src={'/img/no-image.jpeg'}
                                                                        alt="carro"
                                                                        width={283}
                                                                        height={187}
                                                                        sizes="100vw"
                                                                        style={{
                                                                            width: '100%',
                                                                            height: 'auto',
                                                                        }} />
                                                                </div>
                                                        }
                                                    </Swiper>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>

                                <div className="product_info bg-white rounded widget-padding mt-30">
                                    <h4 className="mb-5">Características</h4>
                                    <div className="row g-4">
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="iv_info_item d-flex align-items-center">
                                                <span className="icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0">
                                                    <i className="fa fa-car"></i>
                                                </span>
                                                <div className="info_content">
                                                    <span className="meta">Tipo</span>
                                                    <span className="title">{ad.condition}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="iv_info_item d-flex align-items-center">
                                                <span className="icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0">
                                                    <i className="fa fa-gauge"></i>
                                                </span>
                                                <div className="info_content">
                                                    <span className="meta">Quilometragem</span>
                                                    <span className="title">
                                                        <NumericFormat
                                                            value={ad.mileage ?? 0}
                                                            displayType={'text'}
                                                            thousandSeparator={'.'}
                                                            decimalSeparator={','} />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="iv_info_item d-flex align-items-center">
                                                <span className="icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0">
                                                    <i className="fa fa-gears"></i>
                                                </span>
                                                <div className="info_content">
                                                    <span className="meta">Câmbio</span>
                                                    <span className="title">{ad.transmission}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="iv_info_item d-flex align-items-center">
                                                <span className="icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0">
                                                    <i className="fa fa-palette"></i>
                                                </span>
                                                <div className="info_content">
                                                    <span className="meta">Cor</span>
                                                    <span className="title">{ad.color}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="iv_info_item d-flex align-items-center">
                                                <span className="icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0">
                                                    <i className="fa fa-calendar"></i>
                                                </span>
                                                <div className="info_content">
                                                    <span className="meta">Ano</span>
                                                    <span className="title">{`${ad.yearFabrication}/${ad.yearModel}`}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="iv_info_item d-flex align-items-center">
                                                <span className="icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0">
                                                    <i className="fa fa-gas-pump"></i>
                                                </span>
                                                <div className="info_content">
                                                    <span className="meta">Combustível</span>
                                                    <span className="title">{ad.fuel}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="iv_info_item d-flex align-items-center">
                                                <span className="icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="22"
                                                        height="22"
                                                        viewBox="0 0 200 200"
                                                        fill="currentColor"
                                                    >
                                                        <g transform="translate(0,200) scale(0.1,-0.1)">
                                                            <path d="M765 1851 c-16 -10 -161 -148 -321 -307 -248 -246 -293 -295 -303
                                                            -330 -7 -28 -11 -211 -11 -573 l0 -531 905 0 905 0 0 880 0 880 -572 0 c-540
                                                            0 -575 -1 -603 -19z m1025 -441 l0 -320 -725 0 c-799 0 -785 -1 -785 58 0 15
                                                            4 32 8 37 4 6 129 130 278 278 l270 267 477 0 477 0 0 -320z m-49 -580 c23
                                                            -13 25 -43 3 -64 -12 -13 -38 -16 -120 -16 -58 0 -113 4 -123 10 -28 14 -34
                                                            40 -15 61 15 16 33 19 126 19 60 0 118 -5 129 -10z"/>
                                                        </g>
                                                    </svg>
                                                </span>
                                                <div className="info_content">
                                                    <span className="meta">Portas</span>
                                                    <span className="title">{ad.doors ? `${ad.doors} portas` : '-'}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="iv_info_item d-flex align-items-center">
                                                <span className="icon-wrapper d-inline-flex align-items-center justify-content-center border rounded flex-shrink-0">
                                                    <i className="fa fa-shield"></i>
                                                </span>
                                                <div className="info_content">
                                                    <span className="meta">Blindado</span>
                                                    <span className="title">{ad.armored ? 'Sim' : 'Não'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="mt-40 mb-30" />
                                    <h4 className="mb-40">Sobre o Veículo</h4>
                                    <pre className="formatted-text">{ad.description}</pre>
                                    <hr className="mt-30 mb-30" />
                                    <h4 className="mb-30">Opcionais / Itens de Série</h4>
                                    <div className="row">
                                        {
                                            ad.optionals.map((optional, index) =>
                                                <div className="col-sm-4" key={index}>
                                                    <ul className="iv_ft_list">
                                                        <li><span className="me-2"><i className="fa-solid fa-check"></i></span>{optional}</li>
                                                    </ul>
                                                </div>
                                            )
                                        }
                                    </div>

                                    <hr className="mt-30 mb-30" />
                                    <h4 className="mb-4">Localização</h4>
                                    <div className="map-frame rounded overflow-hidden">
                                        <iframe
                                            src={`https://maps.google.com/maps?q=${company.address} - ${company.city} - ${company.federativeUnit} - ${company.postalCode}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
                                            style={{ border: 0, width: '100%', height: '400px' }}
                                            allowFullScreen
                                            loading="lazy"></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <StickyBox offsetTop={140} offsetBottom={20}>
                                <div className="iv_sidebar mt-5 mt-xl-0">
                                    <div className="iv_sidebar_widget iv_pricing_widget widget-padding bg-secondary rounded">
                                        <h3 className="mb-2 text-white">
                                            {
                                                ad.promotionalPrice
                                                    ?
                                                    ad.price ?
                                                        <NumericFormat
                                                            style={{ color: 'white', fontSize: '14px', textDecoration: 'line-through' }}
                                                            value={ad.price ?? 0}
                                                            displayType={'text'}
                                                            thousandSeparator="."
                                                            decimalSeparator=","
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                            prefix='De R$ ' />
                                                        : 'Consulte-nos'
                                                    : null
                                            }
                                            <p>
                                                {
                                                    ad.price ?
                                                        <NumericFormat
                                                            style={{ color: '#fff' }}
                                                            value={ad.promotionalPrice ? ad.promotionalPrice : ad.price}
                                                            displayType={'text'}
                                                            thousandSeparator="."
                                                            decimalSeparator=","
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                            prefix={`${ad.promotionalPrice ? 'Por R$ ' : 'R$ '}`} />
                                                        : 'Consulte-nos'
                                                } </p>
                                        </h3>
                                        <div className="widget_meta d-flex align-items-center">
                                            <span className="text-white">
                                                <i className="fa-solid fa-gauge-high"></i>
                                                <NumericFormat
                                                    value={ad.mileage ?? 0}
                                                    displayType={'text'}
                                                    thousandSeparator={'.'}
                                                    decimalSeparator={','}
                                                    suffix=' km' />
                                            </span>
                                            <span className="text-white"><i className="fa-solid fa-eye"></i>{`${company.city} - ${company.federativeUnit}`}</span>
                                        </div>
                                        {/* <div className="row g-2">
                                            <div className="col-12 mt-4">
                                                <button
                                                    type="button"
                                                    disabled={formPost.isLoading}
                                                    style={{ width: '100%', fontSize: '18px' }}
                                                    onClick={() => { setShowFinancingModal({ ...showFinancingModal, isOpen: true }); }}
                                                    className="btn btn-info btn-md">Simular Meu Financiamento</button>
                                            </div>
                                        </div> */}
                                    </div>
                                    {/* <div
                                        className="iv_sidebar_widget iv_seller_widget widget-padding bg-white rounded mt-4"
                                        style={{ display: showFinancingModal.isOpen ? 'block' : 'none' }}
                                    >
                                        <div id="credere-pnp"></div>
                                    </div> */}
                                    <div className="iv_sidebar_widget iv_seller_widget widget-padding bg-white rounded mt-4">
                                        <h4 className="mb-30">Envie uma proposta</h4>
                                        <form onSubmit={handleSubmit(onSubmit)} className='seller_offer_form'>
                                            <div className="row g-2">
                                                <div className="col-12">
                                                    <div className="input-field">
                                                        <label>Nome</label>
                                                        <input type="text" {...register("txtName", { required: true })} required={errors.txtName} />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-field">
                                                        <label>Email</label>
                                                        <input type="email" {...register("txtEmail", { required: true, pattern: /^\S+@\S+$/i })} required={errors.txtEmail} />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-field">
                                                        <label>Celular</label>
                                                        <InputMask type={'tel'} mask="(99) 99999-9999" maskChar=" " {...register("txtCellPhone", { required: true })} required={errors.txtCellPhone} />
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-field">
                                                        <label>Mensagem</label>
                                                        <textarea
                                                            {...register("txtMessage", { required: true })}
                                                            required={errors.txtMessage}
                                                            defaultValue={`Olá gostaria de mais informações sobre o veículo ${ad.brand} ${ad.model} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''} - ${ad.yearModel}`}>
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                formPost.isError
                                                    ? <div className="row mt-4">
                                                        <div className="col-12">
                                                            <div className="error-badge bg-primary-light rounded d-block">{formPost.errorText}</div>
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                            {
                                                formPost.isSuccess
                                                    ? <div className="row mt-4">
                                                        <div className="col-12">
                                                            <div className="success-badge bg-primary-success rounded d-block">Proposta enviada com sucesso!</div>
                                                        </div>
                                                    </div>
                                                    : null
                                            }
                                            <div className="row g-2">
                                                <div className="col-6">
                                                    <button
                                                        type="submit"
                                                        disabled={formPost.isLoading}
                                                        style={{ width: '100%' }}
                                                        className="btn btn-secondary btn-md mt-30">Enviar Proposta</button>
                                                </div>
                                                <div className="col-6">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary-whatsapp btn-md mt-30"
                                                        style={{ width: '100%' }}
                                                        onClick={() => {
                                                            const message = `Olá gostaria de mais informações sobre o veículo ${ad.brand} ${ad.model} ${ad.version ? ad.version.toLowerCase().replace(ad.model.toLowerCase(), '') : ''} - ${ad.yearModel}`;
                                                            window.open(`https://api.whatsapp.com/send?phone=+55${company.whatsapp}&text=${company.whatsappDetailsMessage ? company.whatsappDetailsMessage : message} - ${window.location.href}}}}`);
                                                        }}>
                                                        <span className="me-2"><i className="fa-brands fa-whatsapp"></i></span>WhatsApp
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </StickyBox>
                        </div>
                    </div>
                </div>
            </section>
            <Lightbox
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
                slides={ad.photos.map(item => ({ src: item }))}
                plugins={[Fullscreen, Thumbnails, Zoom]} />
            <Lightbox
                open={openYoutubeVideo}
                close={() => setOpenYoutubeVideo(false)}
                slides={[{ type: "youtube", src: ad.videos[0] }]}
                render={{
                    slide: ({ type, src }) =>
                        type === "youtube" ? (
                            <iframe
                                style={{ width: '100%', height: '100%' }}
                                src={src}
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        ) : null
                }}
            />

        </>
    )
}